import { APP_JSON } from '../../constants/common-enums';
import fetchReq from '../../helpers/fetch';
import CONFIG from '../../settings';

const API = {
  /**
   * cardbin API
   *  - returns valid elo bin prefixes
   *
   *  - Fired when user selects
   *  - TODO Unit test script
   * @returns {object} response object
   */
  getCardBins() {
    const options = {
      headers: {
        Accept: APP_JSON,
        'Content-Type': APP_JSON
      },
      method: 'GET',
      url: CONFIG.application.api.cardMetadataSvc.cardBins
    };

    return fetchReq(options);
  }
};

export default API;
